import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./useAuth";

export function RequirePermission(props: { anyOf: string[]; children: React.ReactNode }) {
  const auth = useAuth();

  // If auth is not ready or not logged in, RequireAuth will handle it at a higher level.
  const ok = auth.hasAnyPermission(...(props.anyOf || []));
  if (!ok) return <Navigate to="/forbidden" replace />;
  return <>{props.children}</>;
}
















